import React from "react";
import DataCard from "./DataCard";
import { Link } from "react-router-dom";

function DataDisplay({ dataArr, number }) {
  if (dataArr.length === 0) {
    return (
      <div className="text-white text-3xl h-2/3 flex justify-center items-end mb-20">
        Enter a Number 😊
      </div>
    );
  }
  return (
    <>
      <div className="text-white text-lg text-center h-2/3 flex justify-center items-end mb-20">
        {"Result For Number " + number + "🫡"}
      </div>
      <div className=" flex justify-center items-center flex-wrap mb-10">
        {dataArr.map((data, index) => (
          <DataCard numberData={data} index={index} />
        ))}
      </div>

    </>
  );
}

export default DataDisplay;
